import React, { Fragment, useState } from 'react'

import { AnalyticsEvent } from 'utils/analytics'
import Box from '@mui/material/Box'
import { ClientGalleryUploadFloatingToolBar } from 'components/pages/Gallery/_main/ClientGallery/ClientGalleryFloatingToolBar'
import { ClientPropertySelfUploadPopup } from '../ClientPropertySelfUploadPopup/ClientPropertySelfUploadPopup.module'
import { EmptyContent } from 'components/common/EmptyContent'
import FilterRoundedIcon from '@mui/icons-material/FilterRounded'
import { GRAY_800 } from 'constants/styling/theme'
import { MUIButton } from 'components/common/MUIButton'
import { ToolbarMode } from 'components/pages/Gallery/_main/ClientGallery/_main'
import { VisualFileType } from 'constants/visual'
import { useClientProperty } from '../_main/contexts'
import { useStartOrderForProperty } from '../_main/useStartOrderForProperty'
import { useTranslation } from 'react-i18next'
import { useCanUserOrder } from 'utils/user/canUserOrder'

/**
 * Client Property Empty Visuals Gallery.
 *
 * @example <ClientPropertyEmptyVisualsGallery />
 */
export const ClientPropertyEmptyVisualsGallery: React.FC = () => {
  const { t } = useTranslation(['gallery', 'ai_editing_empty_content'])
  const { startOrder, completionDrawer } = useStartOrderForProperty()

  const { handleClickOnEmptyAction } = useClientProperty()
  const canUserOrder = useCanUserOrder()

  const [isUploadPopupOpened, setIsUploadPopupOpened] = useState(false)

  return (
    <Fragment>

      <Box maxWidth="60rem" width="100%" margin="auto" marginTop="8rem">
        <EmptyContent
          title={t('client_gallery.no_assignment_visual')}
          icon={<FilterRoundedIcon sx={{ color: GRAY_800, fontSize: '2.8rem' }} />}
          button={
            canUserOrder && (
              <MUIButton
                sx={{ marginTop: '2.4rem' }}
                onClick={() => {
                  handleClickOnEmptyAction(AnalyticsEvent.PROPERTY_ORDER_VISUALS_CLICKED)
                  startOrder()
                }}
              >
                {t('client_gallery.no_assignment_visual_action')}
              </MUIButton>
            )
          }
        />
      </Box>

      <ClientGalleryUploadFloatingToolBar
        mode={ToolbarMode.UPLOAD_VISUALS}
        isDownload={false}
        isToolBarOpen={true}
        setIsUploadPopupOpened={setIsUploadPopupOpened}
      />

      {isUploadPopupOpened &&
        <ClientPropertySelfUploadPopup
          isUploadPopupOpened={isUploadPopupOpened}
          setIsUploadPopupOpened={setIsUploadPopupOpened}
          normalizedOriginalType={VisualFileType.POST}
        />
      }

      {completionDrawer}

    </Fragment>
  )
}
